import { wgResource, wgResourceType } from "./wgResource.js";

class wgBuffer extends wgResource {
    constructor(name, context) {
        super(name, context, wgResourceType.wgBuffer);
        this.bufferHandle_ = null;
        this.numberOfElements_ = 0;
        this.elementSize_ = 0;
        this.size_ = 0;
        this.type_ = null;
        this.usage_ = null;
    }

    deleteBuffer() {
        if (this.bufferHandle_ !== null) {
            this.context_.gl().deleteBuffer(this.bufferHandle_);
            this.bufferHandle_ = null;
        }
    }

    bind() {
        this.context_.gl().bindBuffer(this.type_, this.bufferHandle_);
    }

    unbind() {
        this.context_.gl().bindBuffer(this.type_, null);
    }

    getVertexBytesSize(){
        return this.elementSize_;
    }

    createBuffer(type, usage, numElements, elementSize, data) {
        this.numberOfElements_ = numElements;
        this.elementSize_ = elementSize;
        this.size_ = numElements * elementSize;
        this.type_ = type;
        this.usage_ = usage;
        let gl = this.context_.gl(); // for convenience
        let validType = false;
        let validUsage = false;

        // input error checking
        if (
            this.type_ === gl.ARRAY_BUFFER ||
            this.type_ === gl.ELEMENT_ARRAY_BUFFER ||
            this.type === gl.UNIFORM_BUFFER
        ) {
            validType = true;
        }

        if (this.usage_ === gl.DYNAMIC_DRAW || this.usage_ === gl.STATIC_DRAW || this.usage_ === gl.STREAM_DRAW) {
            validUsage = true;
        }

        if (!validType) {
            let errorMessage =
                "wgBuffer: Invalid type for webgl buffer, must be either gl.ARRAY_BUFFER or gl.ELEMENT_ARRAY_BUFFER";
            throw new Error(errorMessage);
        }

        if (!validUsage) {
            let errorMessage =
                "wgBuffer: Invalid usage for buffer, must be either gl.DYNAMIC_DRAW, gl.STATIC_DRAW or gl.STREAM_DRAW";
            throw new Error(errorMessage);
        }

        this.bufferHandle_ = gl.createBuffer();
        this.bind();
        if (data === null) {
            gl.bufferData(this.type_, this.size_, this.usage_);
        } else {
            gl.bufferData(this.type_, data, this.usage_);
        }
        this.unbind();
    }

    //https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/bufferSubData
    // https://forums.expo.io/t/possible-glview-bug/40680
    updateBuffer(offset, data) {
        this.bind();
        this.getContext().gl().bufferSubData(this.type_, offset, data);
        this.unbind();
    }
}

export { wgBuffer };
